/* eslint-disable @typescript-eslint/no-explicit-any */
import CategoryLink from "@/components/atoms/Links/CategoryLink";
import { Locales } from "@/lib/i18n";

interface NavCategoryProps {
  lang?: Locales;
  currentHandle?: string;
  categoryTree?: any;
  currentTree?: any;
  defaultCategory?: any;
}

const NavCategory = ({ lang, currentHandle, categoryTree = null, currentTree = null }: NavCategoryProps) => {
  if (!categoryTree) {
    return null;
  }

  let parentCategory = null;

  if (currentTree && categoryTree.length > 0) {
    categoryTree = categoryTree.find((cat: any) => cat.id === currentTree[0]?.id).children || null;
    if (currentTree.length > 1) {
      parentCategory = currentTree[0];
    }
  }

  const sortedCategoryTree = sortCategoryTree(categoryTree);

  return (
    <>
      <nav>
        <ul>
          {sortedCategoryTree.map((category: any) => (
            <CategoryLink
              key={category.id}
              category={category}
              currentHandle={currentHandle}
              lang={lang}
              parent={parentCategory}
            />
          ))}
        </ul>
      </nav>
    </>
  );
};

export default NavCategory;

function sortCategoryTree(categoryTree: any[]) {
  // Fonction de comparaison pour trier par display
  // Les valeurs null/undefined passent en dernier
  const compareByDisplay = (a: any, b: any) => {
    const displayA = a.data?.display;
    const displayB = b.data?.display;

    // Si les deux sont null/undefined, maintenir l'ordre original
    if (displayA == null && displayB == null) {
      return 0;
    }

    // Si seulement A est null/undefined, B passe avant
    if (displayA == null) {
      return 1;
    }

    // Si seulement B est null/undefined, A passe avant
    if (displayB == null) {
      return -1;
    }

    // Comparaison numérique normale
    return displayA - displayB;
  };

  // Trier les parents
  const sortedParents = [...categoryTree].sort(compareByDisplay);

  // Pour chaque parent, trier ses enfants
  const result = sortedParents.map((parent) => ({
    ...parent,
    children: parent.children ? [...parent.children].sort(compareByDisplay) : [],
  }));

  return result;
}
